import React, { useRef, useState, useEffect } from 'react';
import Modal from 'react-bootstrap/Modal';

import axios from 'axios';
import { Mensaje, MensajeSiNo } from '../mensajes2';
import { Dimmer } from '../spinner';

import moment from 'moment';
import CatalogoCatProgramatica from '../../catalogos/catalogoCategoriaProgramatica';
import CatalogoClasificadorPresupuestario from '../../catalogos/catalogoClasificadorPresupuestario';

export const ImprimirEjGastoPartCuents = (props) => {

    let op = require('../../../src/modulos/datos');
    let token = localStorage.getItem('jwtToken');
    const idefiscal = JSON.parse(localStorage.getItem('idefiscal'));
    const efiscalanio = JSON.parse(localStorage.getItem('efiscalanio'));
    const fechaSistema = JSON.parse(localStorage.getItem('fechasistema'));
    const espiritu = JSON.parse(localStorage.getItem('espiritu'));

    const [activate, setActivate] = useState(false);
    const [deshabilitado, setDeshabilitado] = useState(0);
    const [parameter, setParameter] = useState("");
    const [condi, setCondi] = useState('');
    const [report, setReport] = useState('');
    const [clases, setClases] = useState();
    const [mostrar4, setMostrar4] = useState(false);
    const [mostrar3, setMostrar3] = useState(false);
    const [desde, setDesde] = useState('');
    const [hasta, setHasta] = useState('');
    const [val, setVal] = useState(0);
    const [vpartida, setVpartida] = useState("");
    const [cata, setCata] = useState(0);
    const [gen, setGen] = useState(0);
    const [valor1, setValor1] = useState('00');
    const [valor2, setValor2] = useState('00');
    const [valor3, setValor3] = useState('00');
    const [valor4, setValor4] = useState('00');
    const [valor5, setValor5] = useState('00');
    const [valor6, setValor6] = useState("0000");
    const [valor11, setValor11] = useState('000');
    const [valor21, setValor21] = useState('00');
    const [valor31, setValor31] = useState('00');
    const [valor41, setValor41] = useState('00');
    const [activo, setActivo] = useState(true);
    const [mensaje, setMensaje] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    const [mensajesino, setMensajesino] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    const btnCancela = useRef();
    const btnAcepta = useRef();
    const txtDesde = useRef();
    const txtHasta = useRef();
    const txtChk1 = useRef();
    const txtChk2 = useRef();
    const txtChk3 = useRef();
    const txtCheck = useRef();
    const txtChkd1 = useRef();
    const txtChkd2 = useRef();
    const txtSelectp = useRef();
    const txtSelectpd = useRef();

    const onChangeValidar = (e) => {
        e.preventDefault();
        var sigue = true;
        if (txtHasta.current.value === "") {
            setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Seleccione la Fecha!', icono: 'informacion' });
            sigue = false;
            txtHasta.current.focus();
        } else if (deshabilitado === 1) {

            if (valor11 === "") {
                setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Seleccione la Partida!', icono: 'informacion' });
                sigue = false;
                //txtSelectpd.current.focus();
            } else {
                imprimirGeneral(desde, hasta, cata, condi, vpartida);
            }

        } else if (gen > 0) {

            if (txtSelectp.current && txtSelectp.current.value === "") {
                setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Seleccione la Partida!', icono: 'informacion' });
                sigue = false;
                txtSelectp.current.focus();
            } else {
                imprimirGeneral(desde, hasta, cata, condi, vpartida);
            }

        }

        else if (sigue) {
            imprimirGeneral(desde, hasta, cata, condi, vpartida);
        }

    };

    const onChange = (e) => {

        if (e.target.id === 'desde') {
            setDesde(e.target.value);
        } else if (e.target.id === 'hasta') {
            setHasta(e.target.value);
        }

        if (e.target.id === 'partida') {
            if (e.target.value === '1') {
                setVpartida(" and true");
            } else {
                setVpartida(" AND SUBSTR(puc,1,3) = '" + e.target.value.trim() + "'");
            }
        } else if (e.target.id === 'partidas') {
            if (e.target.value === '1') {
                setVpartida(" and true");
            } else {
                setVpartida(" AND puc = '" + e.target.value.trim() + "'");
            }
        } else if (e.target.id === 'partidasd') {
            setVpartida(" cta_codigo = '" + e.target.value.trim() + "'");
        }
    };

    const onCheck = () => {

        var val = 0;
        if (props.condicion === 'Ejecución del Gasto por Partidas') {

            if (txtChk1.current.checked) {
                setCata(1);
                setGen(1);
                setActivo(true);
            } else if (txtChk2.current.checked) {
                setCata(0);
                setGen(2);
                setActivo(false);
                setValor1("00");
                setValor2("00");
                setValor3("00");
                setValor4("00");
                setValor5("00");
                setValor6("0000");
                setParameter(" AND Categoria >= '0' ");
            }

            if (txtCheck.current.checked === true) {
                setCondi(" AND alcaldia = true");
            } else if (txtCheck.current.checked === false) {
                setCondi(" AND TRUE");
            }

        } else if (props.condicion === 'Ejecución del Gasto por Cuentas') {

            /* if (txtChk1.current.checked) {
                setCata(1);
                setGen(1);
                setActivo(true);
            } else if (txtChk2.current.checked) {
                setCata(0);
                setGen(2);
                setActivo(false);
                setParameter(" AND Categoria >= '0' ");
                setParameter("");
                setValor1("00");
                setValor2("00");
                setValor3("00");
                setValor4("00");
                setValor5("00");
                setValor6("0000");
            } else if (txtChk3.current.checked) {
                setCata(0);
                setGen(3);
                setActivo(false);
                setParameter("");
                setParameter("");
                setValor1("00");
                setValor2("00");
                setValor3("00");
                setValor4("00");
                setValor5("00");
                setValor6("0000");
            }

            if (txtCheck.current.checked === true) {
                setCondi(" AND alcaldia = true");
            } else if (txtCheck.current.checked === false) {
                setCondi(" AND TRUE");
            } */
            let uno = 0;
            let dos = 0;

            if (txtChk1.current.checked) {
                setCata(1);
                setGen(1);
                if (valor1 !== "" && valor1 !== "00") {
                    uno = 1;
                }
            } else if (txtChk2.current.checked) {
                uno = 1;
                setCata(0);
                setGen(2);
                setActivo(false);
                setParameter(" AND Categoria >= '0' ");
                setParameter("");
                setValor1("00");
                setValor2("00");
                setValor3("00");
                setValor4("00");
                setValor5("00");
                setValor6("0000");
            } else if (txtChk3.current.checked) {
                uno = 1;
                setCata(0);
                setGen(3);
                setActivo(false);
                setParameter("");
                setParameter("");
                setValor1("00");
                setValor2("00");
                setValor3("00");
                setValor4("00");
                setValor5("00");
                setValor6("0000");
            }

            if (txtCheck.current.checked === true) {
                setCondi(" AND alcaldia = true");
            } else if (txtCheck.current.checked === false) {
                setCondi(" AND TRUE");
            }

            if (txtChkd1.current.checked) {
                if (valor11 !== "" && valor11 !== "000") {
                    dos = 1;
                }
                setDeshabilitado(1);
            } else if (txtChkd2.current.checked) {
                dos = 1;
                setDeshabilitado(0);
                setVpartida(" AND true ");
                setValor11("000");
                setValor21("00");
                setValor31("00");
                setValor41("00");
            }

            if (uno === 1 && dos === 1) {
                setActivo(false);
            } else {
                setActivo(true);
            }

        } else if (props.condicion === 'Analitico por Partidas') {

            let uno = 0;
            let dos = 0;

            if (txtChk1.current.checked) {
                setCata(1);
                if (valor1 !== "" && valor1 !== "00") {
                    uno = 1;
                }
            } else if (txtChk2.current.checked) {
                uno = 1;
                setCata(0);
                setParameter("");
                setValor1("00");
                setValor2("00");
                setValor3("00");
                setValor4("00");
                setValor5("00");
                setValor6("0000");
            }

            if (txtCheck.current.checked === true) {
                setCondi(" alcaldia = true");
            } else if (txtCheck.current.checked === false) {
                setCondi(" TRUE");
            }

            if (txtChkd1.current.checked) {
                if (valor11 !== "" && valor11 !== "000") {
                    dos = 1;
                }
                setDeshabilitado(1);
            } else if (txtChkd2.current.checked) {
                dos = 1;
                setDeshabilitado(0);
                setVpartida(" true ");
                setValor11("000");
                setValor21("00");
                setValor31("00");
                setValor41("00");
            }

            if (uno === 1 && dos === 1) {
                setActivo(false);
            } else {
                setActivo(true);
            }

        }

    }

    const imprimirGeneral = (desde, hasta, cata, condicion, partida) => {

        let desdec = "";
        let val = 0;
        if (props.condicion === 'Analitico por Partidas') {
            desdec = moment.utc(desde).format('DD-MM-YYYY');
        } else {
            desdec = "01-01-" + efiscalanio;
        }

        let hastac = moment.utc(hasta).format('DD-MM-YYYY');
        var parametro = "";
        var reporte = "";
        var sql6 = " between '" + desdec + "' and '" + hastac + "'";

        if (cata === 1) {
            parametro = " AND Categoria = '" + parameter + "'";
        } else {
            parametro = parameter;
        }


        if (props.condicion === 'Ejecución del Gasto por Partidas') {

            if (espiritu === 9 || espiritu === 12 || espiritu === 14) {
                reporte = 'Pres_CuentasxOrden2NumOrden';
            } else {
                reporte = 'Pres_CuentasxOrden2';
            }
            //setVal(1);
            val = 1;

        } else if (props.condicion === 'Analitico por Partidas') {

            if (espiritu === 9 || espiritu === 12 || espiritu === 13 || espiritu === 14) {

                if (deshabilitado !== 0) {
                    reporte = 'Pres_CAT_AnalisisNumOrdenAuxiliar';
                } else {
                    reporte = 'Pres_CAT_AnalisisNumOrden';
                }

            } else {

                if (deshabilitado !== 0) {
                    reporte = 'Pres_CAT_AnalisisAuxiliar';
                } else {
                    reporte = 'Pres_CAT_Analisis';
                }

            }
            //setVal(2);
            val = 2;

        } else if (props.condicion === 'Ejecución del Gasto por Cuentas') {

            if (gen === 3) {
                reporte = 'Pres_CuentasxOrden2CuentaGen';
            } else {
                if (espiritu === 9 || espiritu === 12 || espiritu === 14) {
                    reporte = 'Pres_CuentasxOrden2NumOrdenCuenta';
                } else {
                    reporte = 'Pres_CuentasxOrden2Cuenta';
                }
            }
            //setVal(1);
            val = 1;
        }

        let fechast = moment.utc(hasta).format('DD/MM/YYYY');
        var valicondi = " MOVIMIENTO.FECHA <= '" + hastac + "'" + parametro + (val === 2 ? " AND " + partida : partida) + condicion;
        console.log(fechast)

        window.open(op.reportes + "/contabilidadpresupuestaria?" + "reporte=" + reporte + "&sql1=" + idefiscal + "&sql2=" + valicondi + "&sql3=" + fechast + "&sql4=" + desdec + "&sql5=" + hastac + "&val=" + val + "&sql6=" + sql6 + "&sql7=" + condicion + "&sql8=" + parametro + "&sql9=" + partida + "&sql10=" + valor6 + "&sql11=" + espiritu, "Planilla", "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700");
    }

    const cancelar = () => {
        blanquear();
        props.onHideCancela();
    }

    const blanquear = () => {
        txtHasta.current.value = '';
        setActivo(true);
        setMostrar4(false);
        setDesde('');
        setHasta('');
        setCata(0);
        setGen(0);
        setDeshabilitado(0);
        setVal(0);
        setVpartida("");
    };


    const handleCloseSi = () => {
        setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
    };


    const cerrarModal = () => {
        setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
        blanquear();
    }

    const catalogoClass = (e) => {
        e.preventDefault();
        setMostrar4(true);
    };

    const catalogoClasiPresu = (e) => {
        e.preventDefault();
        setMostrar3(true);
    };

    const handleCancelaras = () => {
        setMostrar4(false);
    }

    const handleAceptaClasPresupuestaria = (idcategoriaprogramatica, descripcion, categoriaprogramatica) => {
        setMostrar4(false);
        console.log(categoriaprogramatica);
        setValor1(categoriaprogramatica.substring(0, 2));
        setValor2(categoriaprogramatica.substring(2, 4));
        setValor3(categoriaprogramatica.substring(4, 6));
        setValor4(categoriaprogramatica.substring(6, 8));
        setValor5(categoriaprogramatica.substring(8, 10));
        if (txtChkd1.current && txtChkd1.current.checked) {
            if (valor11 !== "" && valor11 !== "000") {
                setActivo(false);
            } else {
                setActivo(true);
            }
        } else if (txtChkd2.current && txtChkd2.current.checked) {
            setActivo(false);
        } else if (txtChkd1.current && txtChkd2.current) {
            setActivo(true);
        } else {
            setActivo(false);
        }
        setParameter(categoriaprogramatica.trim());
    }

    const handleCancelarPartida = () => {
        setMostrar3(false);
    }

    const handleAceptasPartida = (puc, descripcion, auxiliar, idcuenta) => {
        setMostrar3(false);
        setValor11(puc.substring(0, 3));
        setValor21(puc.substring(3, 5));
        setValor31(puc.substring(5, 7));
        setValor41(puc.substring(7, 9));
        setValor6(auxiliar);
        if (txtChk1.current.checked) {
            if (valor1 !== "" && valor1 !== "00") {
                setActivo(false);
            } else {
                setActivo(true);
            }
        } else if (txtChk2.current.checked || (txtChk3.current && txtChk3.current.checked)) {
            setActivo(false);
        } else {
            setActivo(true);
        }
        //setActivo(false);
        //setParameter(" AND cta_codigo = '" + puc.trim() + "' ");
        if (props.condicion === 'Ejecución del Gasto por Cuentas') {
            setVpartida(" AND puc = '" + puc.trim() + "'");
        } else {
            setVpartida(" cta_codigo = '" + puc.trim() + "' ")
        }     
    }

    const seleccionarRegistros = () => {

        setActivate(true);

        let campos = 'puc, trim(descripcion)  AS descripcion, idpuc';
        let camp = "puc";
        let nomtab = 'puc';
        let valor1 = '400000000';
        let valor2 = '999999999';
        let condic = "substr(puc,6,9) != '0000'";
        let nomid = "idefiscal";
        let orden = "puc"

        let endpoint = `${op.conexion}/api/consulta/modeli8?campos=${campos}&id=${idefiscal}&nomtab=${nomtab}&nomid=${nomid}&camp=${camp}&valor1=${valor1}&valor2=${valor2}&condic=${condic}&orden=${orden}`
        console.log(endpoint);
        axios.get(endpoint, {
            headers: {
                "x-access-token": `${token}`,
                'Content-Type': 'application/json'

            },
        }).then(function (response) {

            if (response.status == 200) {

                setActivate(false);
                var datos = []
                for (let i = 0; i < response.data.length; i++) {
                    datos.push({
                        idpuc: response.data[i].idpuc,
                        descripcion: response.data[i].descripcion,
                        puc: response.data[i].puc,
                    })
                }
                setClases(datos)
            }

        }).catch(function (error) {

            setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });

        }).finally(function () {
            setActivate(false);
        });
    }

    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
            backdrop="static"
            keyboard={false}
            onShow={() => {
                let fech = moment.utc(fechaSistema).format('YYYY-MM-DD');
                txtHasta.current.value = fech;

                if (props.condicion === 'Analitico por Partidas') {
                    txtDesde.current.value = fech;
                    setDesde(fech);
                }

                /* if (props.condicion === 'Ejecución del Gasto por Cuentas') {
                    set(fech);
                } */

                setHasta(fech);
                seleccionarRegistros();
            }}

        >
            <Modal.Header className='azulGradiant header-modal'>
                <div className='fw-bold text-light'><h3>{'Imprimir ' + props.condicion}</h3></div>
                <button className="bg-transparent" style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }} onClick={cancelar}>
                    <i className="far fa-window-close"></i>
                </button>

            </Modal.Header>
            <Modal.Body>
                <CatalogoCatProgramatica
                    show={mostrar4}
                    onHideCancelar={handleCancelaras}
                    onHideAceptaCatProgramatica={handleAceptaClasPresupuestaria}
                />
                <CatalogoClasificadorPresupuestario
                    show={mostrar3}
                    onHideCancelar={handleCancelarPartida}
                    onHideAceptar={handleAceptasPartida}
                />
                <Dimmer active={activate} inverted>

                </Dimmer>
                <div className='container-fluid rounded'>

                    <div className="tab-content" id="ex-with-icons-content">
                        <div className="tab-pane fade show active" id="tab-1" role="tabpanel" aria-labelledby="ex-with-icons-tab-1">

                            <fieldset className="row border-azul rounded mx-auto">
                                <legend className="float-none m-0 w-auto" >Datos</legend>

                                <div className='row m-0 px-0 mb-2'>

                                    {props.condicion === 'Analitico por Partidas' ? <div className='col-sm-4 mb-1 px-1 mx-auto'>
                                        <div className="input-group input-group-sm m-0 w-100">
                                            <label className="input-group-text" id="inputGroup-sizing-sm">Desde la Fecha:</label>
                                            <input type="date" className="form-control text-uppercase" onChange={onChange} ref={txtDesde} aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" id="desde" />
                                        </div>
                                    </div> : ''}

                                    <div className='col-sm-4 mb-1 px-1 mx-auto'>
                                        <div className="input-group input-group-sm m-0 w-100">
                                            <label className="input-group-text" id="inputGroup-sizing-sm">Hasta la Fecha:</label>
                                            <input type="date" className="form-control text-uppercase" onChange={onChange} ref={txtHasta} aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" id="hasta" />
                                        </div>
                                    </div>

                                    {props.condicion === 'Analitico por Partidas' ? <div className='row m-0 px-2 col-md-8 mb-2 border-azul rounded'>
                                        <div className="form-check col-md-5 ml-auto py-1 mb-2">
                                            <input className="form-check-input" ref={txtChkd1} onChange={onCheck} type="radio" name="radioPartida" id="radioPartida1" />
                                            <label className="form-check-label" for="radioPartida1">
                                                Seleccionar Partida
                                            </label>
                                        </div>
                                        <div className="form-check col-md-5 ml-auto py-1 mb-2">
                                            <input className="form-check-input" ref={txtChkd2} onChange={onCheck} type="radio" name="radioPartida" id="radioPartida2" />
                                            <label className="form-check-label" for="radioPartida2">
                                                Todas las Partidas
                                            </label>
                                        </div>
                                    </div> : ''}

                                    {props.condicion === 'Ejecución del Gasto por Cuentas' ? <div className='row m-0 px-2 col-md-8 mb-2 border-azul rounded'>
                                        <div className="form-check col-md-5 ml-auto py-1 mb-2">
                                            <input className="form-check-input" ref={txtChkd1} onChange={onCheck} type="radio" name="radioPartida" id="radioPartida1" />
                                            <label className="form-check-label" for="radioPartida1">
                                                Seleccionar Partida
                                            </label>
                                        </div>
                                        <div className="form-check col-md-5 ml-auto py-1 mb-2">
                                            <input className="form-check-input" ref={txtChkd2} onChange={onCheck} type="radio" name="radioPartida" id="radioPartida2" />
                                            <label className="form-check-label" for="radioPartida2">
                                                Todas las Partidas
                                            </label>
                                        </div>
                                    </div> : props.condicion === 'Ejecución del Gasto por Partidas' ? <div className='mb-1 col-sm-8 px-1'>
                                        <div className="input-group input-group-sm m-0 w-100">
                                            <label className="input-group-text" id="inputGroup-sizing-sm">Partida:</label>
                                            <select className="form-select text-center" onChange={onChange} ref={txtSelectp} aria-label="Default select example" id="partida" >
                                                <option value="">--Seleccione---</option>
                                                <option value={1}>TODOS</option>
                                                <option value={401}>401-GASTOS DE PERSONAL</option>
                                                <option value={402}>402-MATERIALES, SUMINISTROS Y MERCANCÍAS</option>
                                                <option value={403}>403-SERVICIOS NO PERSONALES</option>
                                                <option value={404}>404-ACTIVOS REALES</option>
                                                <option value={407}>407-TRANSFERENCIAS Y DONACIONES</option>
                                                <option value={408}>408-OTROS GASTOS</option>
                                                <option value={411}>411-DISMINUCION DE PASIVOS</option>
                                                <option value={498}>498-RECTIFICACIONES AL PRESUPUESTO</option>
                                            </select>
                                        </div>
                                    </div> : ''}

                                    <div className='col-sm-3 mb-1 border-azul rounded py-1 ml-auto'>
                                        <div className="form-check form-check-inline">
                                            <input className="form-check-input" ref={txtCheck} onChange={onCheck} type="checkbox" id="inlineCheckbox1" value="option1" />
                                            <label className="form-check-label" for="inlineCheckbox1">Solo Alcaldía</label>
                                        </div>
                                    </div>

                                    {deshabilitado !== 0 ? <div className='mb-1 col-sm-12 px-1'>
                                        {/* <div className="input-group input-group-sm m-0 w-100">
                                            <label className="input-group-text" id="inputGroup-sizing-sm">Partida:</label>
                                            <select className="form-select text-center" onChange={onChange} ref={txtSelectpd} aria-label="Default select example" id="partidasd" >
                                                <option value="">--Seleccione---</option>
                                                {clases && clases.map((item, index) => (
                                                    <option key={index} value={item.puc} >{item.puc} - {item.descripcion} </option>
                                                ))}
                                            </select>
                                        </div> */}
                                        <table className="table">
                                            <thead>
                                                <tr className='text-center'>
                                                    <th scope="col">Partida</th>

                                                    <th scope="col">Generica</th>

                                                    <th scope="col">Especifica</th>

                                                    <th scope="col">SubEspecificas</th>

                                                    <th scope="col">Auxiliar</th>
                                                </tr>
                                            </thead>
                                            <tbody className='table-bordered'>
                                                <tr className='text-center'>
                                                    <td>{valor11}</td>

                                                    <td>{valor21}</td>

                                                    <td>{valor31}</td>

                                                    <td>{valor41}</td>

                                                    <td>{valor6}</td>

                                                    <td><button onClick={catalogoClasiPresu} className="btn btn-sm  btn-info ml-2" ><i className="fa fa-search"></i> </button></td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div> : ''}

                                </div>

                                <div className='row m-0 px-2 col-md-12 mx-auto mb-2 border-azul rounded'>
                                    <div className="form-check col-md-4 ml-auto py-1 mb-2">
                                        <input className="form-check-input" ref={txtChk1} onChange={onCheck} type="radio" name="flexRadioDefault" id="flexRadioDefault1" />
                                        <label className="form-check-label" for="flexRadioDefault1">
                                            Seleccionar Categoria
                                        </label>
                                    </div>
                                    <div className="form-check col-md-4 ml-auto py-1 mb-2">
                                        <input className="form-check-input" ref={txtChk2} onChange={onCheck} type="radio" name="flexRadioDefault" id="flexRadioDefault2" />
                                        <label className="form-check-label" for="flexRadioDefault2">
                                            Todas las Categorias
                                        </label>
                                    </div>

                                    {props.condicion === 'Ejecución del Gasto por Cuentas' ? <div className="form-check col-md-2 ml-auto py-1 mb-2">
                                        <input className="form-check-input" ref={txtChk3} onChange={onCheck} type="radio" name="flexRadioDefault" id="flexRadioDefault3" />
                                        <label className="form-check-label" for="flexRadioDefault3">
                                            General
                                        </label>
                                    </div> : ''}

                                </div>

                                {cata !== 0 ? <div className='col-md-12 m-0 px-0'>
                                    <table className="table">
                                        <thead>
                                            <tr className='text-center'>
                                                <th scope="col">Sector</th>

                                                <th scope="col">Prog</th>

                                                <th scope="col">SubProg</th>

                                                <th scope="col">Proyec</th>

                                                <th scope="col">Actv</th>

                                            </tr>
                                        </thead>
                                        <tbody className='table-bordered'>
                                            <tr className='text-center'>
                                                <td>{valor1}</td>

                                                <td>{valor2}</td>

                                                <td>{valor3}</td>

                                                <td>{valor4}</td>

                                                <td>{valor5}</td>

                                                <td><button onClick={catalogoClass} className="btn btn-sm  btn-info ml-2" ><i className="fa fa-search"></i> </button></td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div> : ''}

                            </fieldset>

                        </div>
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <button type="button" ref={btnAcepta} disabled={activo} onClick={onChangeValidar} style={{ margin: '1px' }} className="btn btn-success btn-sm rounded-pill"><i className="far fa-check-circle"></i> Imprimir</button>
                <button type="button" ref={btnCancela} onClick={cancelar} style={{ margin: '1px' }} className="btn btn-sm btn-danger rounded-pill"><i className="fas fa-window-close"></i> Cancelar</button>
            </Modal.Footer>
            <Mensaje mensaje={mensaje}
                onHide={() => {
                    mensaje.titulo === 'Exito.' ?
                        cerrarModal() :
                        setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })
                }
                } />
            <MensajeSiNo mensaje={mensajesino}
                onHideNo={() => setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' })} onHideSi={handleCloseSi} />
        </Modal>

    );
}